import React, { useState, useEffect } from 'react';

export default function MaintenanceOverlay() {
  const [active, setActive] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handler = (e) => {
      // When a 503 comes in, re-check if we're the owner before showing
      checkMaintenance();
    };
    window.addEventListener('maintenance-mode', handler);
    return () => window.removeEventListener('maintenance-mode', handler);
  }, []);

  const checkMaintenance = () => {
    const token = localStorage.getItem('token');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    fetch('/api/admin/maintenance-status', { headers })
      .then(r => r.json())
      .then(data => {
        if (data.active && !data.bypass) {
          setActive(true);
          setMessage(data.reason || 'Website is under maintenance. Please check back later.');
        } else {
          setActive(false);
        }
      })
      .catch(() => {});
  };

  // Check on mount
  useEffect(() => {
    checkMaintenance();
  }, []);

  if (!active) return null;

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      zIndex: 99999,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0a0a0f 0%, #1a1a2e 50%, #0a0a0f 100%)',
      color: '#fff',
      fontFamily: "'Inter', -apple-system, sans-serif",
    }}>
      <div style={{
        textAlign: 'center',
        maxWidth: 500,
        padding: '40px',
      }}>
        <div style={{ fontSize: 64, marginBottom: 24 }}>🔧</div>
        <h1 style={{
          fontSize: 28,
          fontWeight: 700,
          margin: '0 0 16px',
          background: 'linear-gradient(135deg, #00ff88, #00cc6a)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}>
          Under Maintenance
        </h1>
        <p style={{
          fontSize: 16,
          color: 'rgba(255,255,255,0.7)',
          lineHeight: 1.6,
          margin: 0,
        }}>
          {message}
        </p>
        <div style={{
          marginTop: 32,
          padding: '12px 24px',
          background: 'rgba(255,255,255,0.05)',
          borderRadius: 8,
          border: '1px solid rgba(255,255,255,0.1)',
          fontSize: 13,
          color: 'rgba(255,255,255,0.5)',
        }}>
          GV-Security will be back shortly.
        </div>
      </div>
    </div>
  );
}
